import axios from 'axios';

// Create axios instance with base configuration
// For production: Set REACT_APP_API_URL environment variable to your backend URL
// For development: Uses proxy from package.json
const getBaseURL = () => {
  // Priority 1: Use environment variable if set (for production)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Priority 2: For development, use empty string (proxy handles it)
  // This allows package.json proxy to work
  if (process.env.NODE_ENV === 'development') {
    return '';
  }
  
  // Priority 3: Production fallback - assume backend is on same domain, different port
  // Or use window.location.origin if frontend and backend are on same domain
  const origin = window.location.origin;
  
  // If frontend is on port 3000, assume backend is on 8000
  if (origin.includes(':3000')) {
    return origin.replace(':3000', ':8000');
  }
  
  // Otherwise, try to use same origin (if backend is on same domain)
  // Or fallback to localhost for development
  return origin || 'http://localhost:8000';
};

const api = axios.create({
  baseURL: getBaseURL(),
  timeout: 60000, // 60 seconds timeout for large queries
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Unauthorized - redirect to login
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api; 